const {Component} = require("react");
const PropTypes = require("prop-types");
const {classList} = require("helpers/html");
const router = require("services/router");
const moment = require("moment");
const {onSameDay} = require("helpers/moment");

class Booking extends Component {

	static get propTypes() {
		return {
			id: PropTypes.number.isRequired,
			from: PropTypes.string.isRequired,
			to: PropTypes.string.isRequired,
			booker: PropTypes.object.isRequired,
			bookable: PropTypes.object.isRequired,
			order: PropTypes.object.isRequired,
			location: PropTypes.string.isRequired,
			distance: PropTypes.number.isRequired,
			viewAs: PropTypes.string,
			defaultAvatarUrl: PropTypes.string
		};
	}

	static get defaultProps() {
		return {
			viewAs: "bookable",
			defaultAvatarUrl: "img/avatar-placeholder.png"
		};
	}

	get className() {
		return classList(
			"lesson",
			this.props.viewAs === "bookable" ? 'received' : null
		);
	}

	get person() {
		return this.props.viewAs === "bookable" ?
			this.props.booker : this.props.bookable;
	}

	get recipients() {
		if (this.props.viewAs !== "bookable") {
			return [this.props.bookable];
		}

		const recipients = [].concat(this.props.order.subuserRecipients);

		if (this.props.order.userRecipient) {
			recipients.unshift(this.props.order.userRecipient);
		}

		return recipients;
	}

	renderRecipients() {
		return this.recipients.map(recipient => {
			const url = recipient.avatar ? recipient.avatar.url : router.url(this.props.defaultAvatarUrl);
			return (<img key={recipient.id} src={url} alt={recipient.name}/>);
		});
	}

	render() {
		const from = moment(this.props.from);
		const to = moment(this.props.to);
		const person = this.person;
		const {location, distance} = this.props;
		const day = onSameDay(from, moment()) ? "I dag" : from.format("DD[.] MMMM YYYY");

		return (
			<div className={this.className}>
				<div className="col">
					<p className="time">{from.format("HH:mm")} - {to.format("HH:mm")}</p>
					<p className="name">{person.name}</p>
					<p>{location} - {distance}km væk</p>
				</div>
				<div className="col">
					<p className="when">{day}</p>
					<div className="img-wrap">{this.renderRecipients()}</div>
				</div>
			</div>
		);
	}

}

module.exports = Booking;



// WEBPACK FOOTER //
// ./resources/js/components/backend/upcoming-bookings/Booking.js